import React from 'react';
import { Upload, message, Typography } from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { useUploadConfig } from '../util/useUploadConfig';

const { Text } = Typography;

const UploadImageUploader = ({
    profileType = 'GENERIC',
    value, // This is the image URL passed from form or parent
    onChange, // Function to call when upload completes successfully
    onPreviewImage, // Function to call when we want to preview for Cropper
    isUploading = false, // Loading state from parent if using customRequest
    children, // Custom upload button if needed
    ...restProps
}) => {
    const { getProfile } = useUploadConfig();
    const profile = getProfile(profileType);

    const beforeUpload = (file) => {
        const validExtensions = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/gif'];
        if (!validExtensions.includes(file.type)) {
            message.error("You can only upload JPG/PNG/WEBP files!");
            return false;
        }

        const isWithinLimit = file.size / 1024 / 1024 <= profile.maxUploadMB;
        if (!isWithinLimit) {
            message.error(`Image size exceeds maximum allowed limit (${profile.maxUploadMB} MB).`);
            return false;
        }

        if (onPreviewImage) {
            const reader = new FileReader();
            reader.addEventListener('load', () => {
                onPreviewImage(reader.result, file);
            });
            reader.readAsDataURL(file);
            return false; // Prevent auto upload if parent handles it (e.g. Cropper)
        }
        
        return true; 
    };

    const uploadButton = children || (
        <div>
            {isUploading ? <LoadingOutlined /> : <PlusOutlined />}
            <div style={{ marginTop: 8 }}>Upload</div>
        </div>
    );

    return (
        <div className="upload-image-uploader">
            <Upload
                name="image"
                listType={children ? "text" : "picture-card"}
                className={children ? "upload-full-width" : ""}
                showUploadList={false}
                beforeUpload={beforeUpload}
                onChange={onChange} // Typically antd handles this, but we allow override
                {...restProps}
            >
                {value && !onPreviewImage ? (
                    <img
                        src={value}
                        alt="preview"
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                ) : (
                    uploadButton
                )}
            </Upload>
            
            <div style={{ marginTop: '8px', fontSize: '12px', lineHeight: '1.4' }}>
                <Text type="secondary" style={{ display: 'block' }}>
                    Maximum Upload: <strong>{profile.maxUploadMB} MB</strong>
                </Text>
                <Text type="secondary" style={{ display: 'block' }}>
                    Automatically Optimized: <strong>≈{profile.targetKB} KB WebP</strong>
                </Text>
                <Text type="secondary" style={{ display: 'block' }}>
                    Recommended: <strong>{profile.width}×{profile.height}</strong>
                </Text>
            </div>
        </div>
    );
};

export default UploadImageUploader;
